import { render, staticRenderFns } from "./subpage.vue?vue&type=template&id=12a27745"
import script from "./subpage.vue?vue&type=script&lang=js"
export * from "./subpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports